import { Head } from '@inertiajs/react';
import Markdown from 'react-markdown'
import ResponsiveImage from '@/components/responsive-image';
import Layout from '@/layouts/layout';

export default function About({bio}) {
    const {data} = bio;
    const {title, body, banner, images} = data;
    return (
        <Layout>
            <Head title="About" />
            <div className='py-12 px-4'>
                {banner && (
                    <div>
                        <ResponsiveImage
                            fetchPriority='high'
                            className="object-contain rounded-sm border shadow-lg"
                            srcSet={banner.srcSet}
                            height={banner.width}
                            width={banner.height}
                            alt={`${banner.alt}`}
                        />
                        <span className='text-sm font-medium'>© {banner?.attribution?.name}</span>
                    </div>
                )}

                <p className="text-3xl py-8 font-medium">{title}</p>
                <div className='prose lg:prose-xl prose-zinc dark:prose-invert'>
                    <Markdown>{body}</Markdown>
                </div>

                <div className='grid grid-cols-3 gap-4 py-8'>
                    {images && images.map((image, idx) => (
                        <a key={idx} href={image.url}>
                            <ResponsiveImage
                                loading='lazy'
                                className="object-contain rounded-sm border shadow-lg"
                                src={image.url}
                                srcSet={image.srcSet}
                                height={image.width}
                                width={image.height}
                                alt={`${image.alt}`}
                            />
                            <span className='text-sm font-medium'>© {image?.attribution?.name}</span>

                        </a>
                    ))}
                </div>
            </div>
        </Layout>
    );
}
